export default "__VITE_ASSET__CXlpYNKc__"